(() => {
  const root = document.getElementById('wj-promo-first-purchase');
  if (!root) return;
  const key = 'webjoias-first-purchase-popup-v1';
  try {
    if (sessionStorage.getItem(key) === '1') return;
  } catch (_) {}
  const dialog = root.querySelector('[role="dialog"]');
  const closeButton = root.querySelector('.wj-promo__close');
  let previousFocus = null;
  let opened = false;
  const hide = () => {
    if (!opened) return;
    root.hidden = true;
    document.documentElement.classList.remove('wj-promo-active');
    document.removeEventListener('keydown', onKeyDown, true);
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
    opened = false;
  };
  const onKeyDown = (event) => {
    if (event.key === 'Escape') { event.preventDefault(); hide(); return; }
    if (event.key !== 'Tab') return;
    const el = dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled])');
    if (!el.length) { event.preventDefault(); dialog.focus(); return; }
    const first = el[0], last = el[el.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  };
  root.querySelectorAll('[data-wj-promo-close]').forEach(el => el.addEventListener('click', hide));
  const show = () => {
    if (opened || !root.isConnected) return;
    opened = true;
    previousFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('wj-promo-active');
    document.addEventListener('keydown', onKeyDown, true);
    closeButton.focus({ preventScroll: true });
    try { sessionStorage.setItem(key, '1'); } catch (_) {}
  };
  const launch = () => window.setTimeout(show, 800);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', launch, { once: true });
  else launch();
})();